import React from 'react';
import {
  BackgroundExportStatus,
  BackgroundExportTypes,
} from 'further-types/background-exports';
import DownloadTray from './DownloadTray';
import { CalendarTime } from 'utils';

interface DownloadTrayContainerProps {
  iconColor?: string;
  borderColor?: string;
  backgroundExports: Array<{
    _id: string;
    exportType: BackgroundExportTypes;
    status: BackgroundExportStatus;
    createdAt?: CalendarTime;
    downloaded: boolean;
    additionalLabel?: string;
  }>;
  downloadBackgroundExport: (exportId: string) => void;
  deleteBackgroundExport: (exportId: string) => void;
  Heading?: React.ReactNode;
}

const DownloadTrayContainer: React.FC<DownloadTrayContainerProps> = ({
  iconColor,
  borderColor,
  backgroundExports,
  downloadBackgroundExport,
  deleteBackgroundExport,
  Heading,
}) => {
  if (
    backgroundExports.every(
      (backgroundExport) =>
        backgroundExport.downloaded ||
        backgroundExport.status === BackgroundExportStatus.Failed,
    )
  ) {
    return null;
  }

  return (
    <DownloadTray
      iconColor={iconColor}
      borderColor={borderColor}
      backgroundExports={backgroundExports}
      downloadBackgroundExport={downloadBackgroundExport}
      deleteBackgroundExport={deleteBackgroundExport}
      Heading={Heading}
    />
  );
};

export default DownloadTrayContainer;
